// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ChangePrice--next-sr-only--qha-Ej6","change-price-container":"ChangePrice--change-price-container--2J6zm-9","footer":"ChangePrice--footer--AK_7-BQ"};